import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { LoanProgressData , dashboardApi } from "../home/dashboardService";

export interface DashboardState {
  isDocumentUploadEnabled: boolean;
  loanProgress?: LoanProgressData;
}

const initialState: DashboardState = {
  isDocumentUploadEnabled: true,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    disableDocumentUpload: (state) => {
      return { ...state, isDocumentUploadEnabled: false };
    },
    enableDocumentUpload: (state) => {
      return { ...state, isDocumentUploadEnabled: true };
    },
    setLoanProgress: (state, action: PayloadAction<LoanProgressData>) => {
      state.loanProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(dashboardApi.endpoints.getLoanStatus.matchFulfilled, (state, action) => {
        state.loanProgress = action.payload;
      });
  },
});

export const { disableDocumentUpload, enableDocumentUpload, setLoanProgress } = dashboardSlice.actions;

export const isDocumentUploadEnabled = (state: RootState): boolean => state.dashboard.isDocumentUploadEnabled;

export const getLoanProgress = (state: RootState): LoanProgressData | undefined => state.dashboard.loanProgress;

export default dashboardSlice.reducer;
